import { render } from "./BaseWidget.vue?vue&type=template&id=fcab0262&scoped=true"
import script from "./BaseWidget.vue?vue&type=script&lang=js"
export * from "./BaseWidget.vue?vue&type=script&lang=js"

import "./base-widget.scss?vue&type=style&index=0&id=fcab0262&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcab0262"]])

export default __exports__